import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'LISTING_CONTENT' });



// WEBPACK FOOTER //
// ./src/frontend/modules/content/listing-content/handlers.js